import React from 'react';
import {useParams} from 'react-router';
import {useLocalization} from 'localization';
import {useGetAgentQuery} from 'services/agent/agentApi';
import {ActivityIndicator, Scene} from 'components';
import {useSceneExtensionsContext} from 'sceneExtensions';
import {CompareAgents} from './components/CompareAgents';

export const MergeAgentsSceneCore: React.FC = () => {
  const {t} = useLocalization();
  const {currentExtension} = useSceneExtensionsContext();
  const {agentId: agentIdParam, otherId: otherIdParam} = useParams();

  const {data: agentData, isLoading: agentIsLoading} = useGetAgentQuery({
    id: agentIdParam || '',
  });
  const {data: otherData, isLoading: otherIsLoading} = useGetAgentQuery({
    id: otherIdParam || '',
  });

  const isLoading = agentIsLoading || otherIsLoading;

  return (
    <Scene
      browserTitle={t('appbar.agents')}
      rightPanelConfig={currentExtension?.panelConfig}>
      <Scene.Header title={'Agentsammenslåing'} />
      <Scene.Content>
        {isLoading ? (
          <ActivityIndicator />
        ) : agentData && agentData.id && otherData && otherData.id ? (
          <>
            <CompareAgents agentId={agentData.id} otherId={otherData.id} />
          </>
        ) : (
          <div>Ugyldig serie IDer.</div>
        )}
      </Scene.Content>
      {currentExtension ? (
        <Scene.RightPanel>
          {currentExtension.renderRightPanel()}
        </Scene.RightPanel>
      ) : null}
    </Scene>
  );
};
